<template>
  <div class="ranking">
    <div class="taber">
      <touch class="tab" :class="{active: isPersonRanking()}" @tap="showPersonRanking">
        <div class="inner">个人累计捐赠</div>
      </touch>
      <touch class="tab" :class="{active: isGroupRanking()}" @tap="showGroupRanking">
        <div class="inner">高校累计捐赠</div>
      </touch>
    </div>
    <div class="contenter">
      <div class="content" :class="{active: isPersonRanking()}">
        <person-ranking />
      </div>
      <div class="content" :class="{active: isGroupRanking()}">
        <group-ranking />
      </div>
    </div>
  </div>
</template>

<script>
  import PersonRanking from '@/components/PersonRanking'
  import GroupRanking from '@/components/GroupRanking'

  export default {
    name: 'ranking',
    data () {
      return {
        current: 'person'
      }
    },
    activated () {
      this.checkRouterParams()
      this.$track.sendPageTrack('csr_rank')
    },
    methods: {
      checkRouterParams () {
        if (this.$route.params.tab) {
          this.current = this.$route.params.tab
        }
      },
      isPersonRanking () {
        return this.current === 'person'
      },
      isGroupRanking () {
        return this.current === 'group'
      },
      showPersonRanking () {
        this.$track.sendActionTrack('csr_rank', 'click_switch_tab', {
          tab: 1
        })
        this.current = 'person'
      },
      showGroupRanking () {
        this.$track.sendActionTrack('csr_rank', 'click_switch_tab', {
          tab: 2
        })
        this.current = 'group'
      }
    },
    components: {
      PersonRanking,
      GroupRanking
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .ranking {
    width: 100%;
    background-color: $grey;
    box-sizing: border-box;
    .taber {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      display: flex;
      width: 100%;
      height: 100px;
      background-color: $white;
      box-sizing: border-box;
      .tab {
        position: relative;
        width: 50%;
        height: 100px;
        padding-top: 30px;
        padding-bottom: 30px;
        font-size: 32px;
        color: rgba($black, 0.54);
        line-height: 40px;
        text-align: center;
        box-sizing: border-box;
        .inner {
          height: 40px;
        }
        &:first-child {
          .inner {
            border-right: 1px solid $deepGrey;
          }
        }
        &.active {
          color: $black;
          &::after {
            position: absolute;
            left: 50%;
            bottom: 2px;
            content: '';
            display: block;
            width: 20px;
            height: 8px;
            margin-left: -10px;
            background-color: $orange;
          }
        }
      }
    }
    .contenter {
      position: absolute;
      width: 100%;
      height: 100%;
      padding-bottom: 130px;
      background-color: $white;
      box-sizing: border-box;
      overflow: hidden;
      .content {
        display: none;
        position: relative;
        height: 100%;
        padding-top: 130px;
        background-color: $grey;
        box-sizing: border-box;
        overflow: scroll;
        &.active {
          display: block;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// Ranking.vue?58fd17b2